import { createFileRoute } from '@tanstack/react-router'
import { ProfilePage } from '#pages/client/ProfilePage'

export const Route = createFileRoute('/_app/profile')({
  component: ProfilePage,
})
